import { PERMISSION_ACTIONS } from '../core';

const PAYMENT_TYPE_TO_ACTION = {
  expenses: PERMISSION_ACTIONS.CANCEL_EXPENSES_PAYMENT,
  indemnity: PERMISSION_ACTIONS.CANCEL_INDEMNITY_PAYMENT,
  general_expenses: PERMISSION_ACTIONS.CANCEL_GENERAL_EXPENSES_PAYMENT,
};

export const paymentTypeToPermissionAction = (paymentType) => PAYMENT_TYPE_TO_ACTION[paymentType];
